///-- THIS FILE IS GENERATED --///
export enum ListStyleType {

    LIST_DECIMAL = "pinata-list-decimal",

    LIST_DISC = "pinata-list-disc",

    LIST_NONE = "pinata-list-none",

}